import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { CSSTransitionGroup } from 'react-transition-group';
import NewPostMessage from '../../components/new-post-message';
import { hideNewPostMessage, hideNewPostMessageDebounced } from '../../actions/hide-new-post-message';
import { getCurrentUserId } from '../../selectors/current-user-selectors';
import { getPost } from '../../selectors/post-selectors';

const DEBOUNCE_TIME = 4000;
const ANIMATION_TIMEOUT = 200;

export class NewPostMessageRoot extends Component {
  static propTypes = {
    postId: PropTypes.string,
    currentUserId: PropTypes.string,
    post: PropTypes.object,
    header: PropTypes.object.isRequired,
    hideNewPostMessage: PropTypes.func.isRequired,
    hideNewPostMessageDebounced: PropTypes.func.isRequired,
    pathname: PropTypes.string.isRequired,
  };

  state = {
    isMessageVisible: false,
  };

  componentWillReceiveProps({ postId, post }) {
    if (this.props.postId !== postId && postId) {
      const isMessageVisible = !this.isInViewport(postId) && !this.isOwnPost(post);
      if (isMessageVisible) {
        this.props.hideNewPostMessageDebounced(DEBOUNCE_TIME);
      } else {
        this.props.hideNewPostMessage();
      }

      this.setState({ isMessageVisible });
    } else if (!postId) {
      this.setState({
        isMessageVisible: false,
      });
    }
  }

  isInViewport(postId) {
    const { header } = this.props;
    const postElement = document.getElementById(postId);
    const headerOffset = header.offset + header.height;
    const postRect = postElement.getBoundingClientRect();

    return postRect.top >= headerOffset && postRect.top < window.innerHeight;
  }

  isOwnPost(post) {
    return post.ownerId === this.props.currentUserId;
  }

  render() {
    const { postId, pathname, hideNewPostMessage } = this.props;
    const { isMessageVisible } = this.state;
    return (
      <CSSTransitionGroup
        component="div"
        transitionName="message"
        transitionEnterTimeout={ANIMATION_TIMEOUT}
        transitionLeaveTimeout={ANIMATION_TIMEOUT}
      >
        {isMessageVisible ? <NewPostMessage postId={postId} pathname={pathname} onClick={hideNewPostMessage}/> : null}
      </CSSTransitionGroup>
    );
  }
}

const mapStateToProps = state => ({
  header: state.header,
  postId: state.newPostMessage,
  post: getPost(state, state.newPostMessage),
  currentUserId: getCurrentUserId(state),
});

const mapDispatchToProps = {
  hideNewPostMessage,
  hideNewPostMessageDebounced,
};

export default connect(mapStateToProps, mapDispatchToProps)(NewPostMessageRoot);



// WEBPACK FOOTER //
// ./app/containers/new-post-message-root/new-post-message-root.js